export default "/890111dfad6266562826aaa0c8b0b6b71032c800/062e30a7ac6b62636e98a277a6442dbf.svg";